import { Component, Input, OnInit } from '@angular/core';
import { CookiesService } from "../../services/cookies/cookies.service";

@Component({
    selector: 'say-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {

    @Input() ident: string = 'default';

    public isVisible: boolean = false;

    constructor(private cookiesService: CookiesService) {}

    ngOnInit() {
        this.isVisible = this.cookiesService.getCookie(this.cookieName) !== 'true';
    }

    public close(): void {
        this.isVisible = false;
        this.cookiesService.setCookie(this.cookieName, 'true', 365 * 5);
    }

    public get bannerId(): string {
        return ['banner', this.ident].join('-');
    }

    public get textId(): string {
        return [this.bannerId, 'text'].join('-');
    }

    public get closeButtonId(): string {
        return [this.bannerId, 'close', 'button'].join('-');
    }

    public get cookieName(): string {
        return [this.bannerId, 'is', 'closed'].join('-');
    }
}
